import { render, staticRenderFns } from "./CustoEventoPatrimonioForm.vue?vue&type=template&id=baf275ea&scoped=true"
import script from "./CustoEventoPatrimonioForm.vue?vue&type=script&lang=js"
export * from "./CustoEventoPatrimonioForm.vue?vue&type=script&lang=js"
import style0 from "./CustoEventoPatrimonioForm.vue?vue&type=style&index=0&id=baf275ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf275ea",
  null
  
)

export default component.exports